import axios from 'axios';

// 환경변수에서 API URL 가져오기 (없으면 기본값 사용)
const API_BASE_URL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:8000';

console.log(`API 서버 주소: ${API_BASE_URL}`);

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 7200000, // 타임아웃
});

// 요청 인터셉터
apiClient.interceptors.request.use(
  (config) => {
    // 필요시 토큰 추가
    // const token = localStorage.getItem('token');
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // }
    console.log(`[${config.method?.toUpperCase()}] ${config.url}`);
    return config;
  },
  (error) => {
    console.error('요청 오류:', error);
    return Promise.reject(error);
  }
);

// 응답 인터셉터
apiClient.interceptors.response.use(
  (response) => {
    console.log(`[응답 ${response.status}] ${response.config.url}`);
    return response;
  },
  (error) => {
    if (error.response) {
      // 응답 상태 코드가 2xx 범위를 벗어남
      console.error(`API 오류 [${error.response.status}]:`, error.response.data);
    } else if (error.request) {
      // 요청이 이루어졌으나 응답이 없음
      console.error('응답 없음:', error.request);
    } else {
      // 요청 설정에서 오류가 발생함
      console.error('요청 설정 오류:', error.message);
    }
    return Promise.reject(error);
  }
);

export default apiClient;
